module.exports = __webpack_public_path__ + "static/media/oh_pack2_sample004_0001.556aa4a1.png";